import React, {Fragment, ReactNode} from 'react';

import cs from 'classnames';
import styled from 'styled-components';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';

export interface BreadcrumbProps {
  active?: boolean;
  link?: string;
  icon?: string;
  text: ReactNode;
  shrinkText?: boolean;
  grow?: boolean;
  onClickItem?: ($event: React.MouseEvent<HTMLLinkElement>) => void;
}
export const BreadcrumbItemStructure = ({
  active = false,
  link,
  icon,
  text,
  grow,
  onClickItem,
  shrinkText = false,
}: BreadcrumbProps): JSX.Element => {
  const content = (
    <Fragment>
      {icon != null ? (
        <i className={cs('fa fa-fw', {'mr-sm-1': text}, icon)} />
      ) : null}
      <span className={icon != null ? 'd-none d-sm-inline' : ''}>{text}</span>
    </Fragment>
  );
  return (
    <StyledBreadcrumbLi
      className={cs({
        active: active,
        'text-truncate': shrinkText,
        'flex-grow-1': grow,
      })}
    >
      {!active && link != null ? (
        <FullHTMLLink html_url={link} onClick={onClickItem}>
          {content}
        </FullHTMLLink>
      ) : (
        content
      )}
    </StyledBreadcrumbLi>
  );
};

const StyledBreadcrumbLi = styled.li.attrs<{className?: string}>({
  className: 'breadcrumb-item',
})`
  white-space: nowrap;
`;
